<template>
  <div>
    <Header
      :history="history"
      :data="drawerData"
      @goBack="goBack"
      @close="close"
    />

    <transition name="fade">
      <Preview
        :data="drawerData"
        @change="change"
        @close="close"
      />
    </transition>

    <div
      v-if="isLoading"
      class="progress__wrapper text-xs-center py-5"
      :style="`height: ${contentHeight}px`"
    >
      <div class="progress">
        <v-progress-circular indeterminate color="accent" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { calcContentHeight } from 'utils/functions'
import Header from './Header'
import Preview from './Preview'

export default {
  name: 'Voucher',
  props: {
    data: {
      type: Object,
      default: () => {}
    },

    actionType: {
      type: String,
      default: 'preview'
    },

    history: {
      type: Array,
      default: () => []
    },

    drawerType: {
      type: String,
      required: true
    }
  },
  components: {
    Header,
    Preview
  },
  computed: {
    ...mapState({
      company: ({ company }) => company.selectedCompany
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      currentStatus: null,
      drawerData: {},
      contentHeight: 'none',
      action: 'preview'
    }
  },
  methods: {
    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload) {
      this.action = 'preview'
      this.$emit('close', reload)
    },

    // REMOVER
    change (val) {
      this.$emit('change', val)
    },

    loadData () {
      this.currentStatus = STATUS_IS_LOADING

      try {
        this.drawerData = this.data

        this.$emit('updateHistory', {
          drawerType: 'voucher',
          data: this.data
        })

        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR:', err)
        this.currentStatus = STATUS_FAILED
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.loadData()
      }
    },

    company () {
      this.close()
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
    this.loadData()
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>
